// extracted by mini-css-extract-plugin
module.exports = {"title":"modal_title__1gkQk","titleRed":"modal_titleRed__FA9c8","content":"modal_content__1to38","actions":"modal_actions__2UT_M"};